﻿/*globals AggregatorRepositoryDTO*/

import jquery from 'jquery';
import AggregatorRepository from '../repositories/aggregator-repository';
import HabEvents from '../../Global/habitaclia-events';

class Aggregator {

    constructor() {
        this._aggRepository = new AggregatorRepository(AggregatorRepositoryDTO);

        this._numberItems = 0;
        this._actualPage = 0;
        this._totalPages = 0;
        this._listHeight = 220;

        this._$aggListContainer = jquery('#js-list-agg');
        this._$nextBtn = jquery('#js-list-agg-next');
        this._$prevBtn = jquery('#js-list-agg-prev');
        this._$aggList = jquery('#js-list-agg-container .list-agg-items');
        
        
        if (this._$aggList.length > 0) {
            this._listWidth = this._$aggListContainer.width();
            this._getAggregatorItems();
        }
        
    }

    _registerEvents() {

        this._$nextBtn.click(() => {

            if (this._actualPage < this._totalPages - 1) 
            {
                this._$prevBtn.css('display', 'block');
                this._actualPage = this._actualPage + 1;
                this._$aggList.css('transform', 'translate(0, -' + this._listHeight * this._actualPage + 'px)');
                
                if (this._actualPage === this._totalPages - 1) 
                {
                    this._$nextBtn.css('display', 'none');
                }
            }

            jquery.publish(HabEvents.EventsEnum.ClickSiguienteElementoAgregador);
        });

        this._$prevBtn.click(() => 
        {
            if (this._actualPage > 0) 
            {
                this._$nextBtn.css('display', 'block');
                this._actualPage = this._actualPage - 1;
                this._$aggList.css('transform', 'translate(0, -' + this._listHeight * (this._actualPage) + 'px)');
                if (this._actualPage === 0) {
                    this._$prevBtn.css('display', 'none');
                } 
            }

            jquery.publish(HabEvents.EventsEnum.ClickAnteriorElementoAgregador);
        });


        jquery('.list-agg-item').click(function () {

            jquery.publish(HabEvents.EventsEnum.ClickItemAgregador);
           
        });


    }

    _getAggregatorItems() {

        this._aggRepository.getItems()
            .then((infoAgg) => {

                if (infoAgg !== "" || infoAgg.length > 0 ) 
                {
                    this._numberItems = infoAgg.length;
                    this._totalPages = this._numberItems / 5;

                    if (this._numberItems > 0) 
                    {
                        this._$aggListContainer.css('display', 'block');
                        
                        for (let i = 0; i < this._numberItems; i++) {
                            this._addItem(infoAgg[i]);
                        }

                        if (this._numberItems <= 5) {
                            this._$nextBtn.css('display', 'none');
                        }

                        this._registerEvents();
                    }
                }
          
            });

    }

    _addItem(data) {
        
        const liTemplate = document.getElementById('{{list-agg-item-template}}').cloneNode(true);
        const $liTemplate = jquery(liTemplate);
        $liTemplate.find('a')[0].href = data.url;
        $liTemplate.find('img')[0].src = data.image;
        $liTemplate.find('.agg-item-price')[0].innerHTML = data.price;
        $liTemplate.find('.agg-item-specs')[0].innerHTML = data.specs;
        $liTemplate.find('.agg-item-title')[0].innerHTML = data.titleShort;
        $liTemplate.find('.agg-item-geo')[0].innerHTML = data.locationShort;
        $liTemplate.css('display', 'inline-block');
        $liTemplate[0].id = '';
        
        this._$aggList.append($liTemplate);
    }

   

}

new Aggregator();